export default __webpack_public_path__ + "static/media/03_ampelwide-rot.055f10ae.png";